

(function popupServiceDefinition() {

    angular.module('Popup')
        .service('popup', ['$position', '$templateCache', '$compile', '$timeout', '$http', '$q',
            function popupService($position, $templateCache, $compile, $timeout, $http, $q) {
                
                function getCoords (originCoords, popupEl, options) {
                    
                    var placements = options.placement.split('-');
                    var pos0 = placements[0],
                        pos1 = placements[1] || 'center';

                    var placement;
                    var popupWidth = popupEl.outerWidth();
                    var popupHeight = popupEl.outerHeight();

                    var shiftWidth = {
                        center: function () {
                            return originCoords.left + originCoords.width / 2 - popupWidth / 2;
                        },
                        left: function () {
                            return originCoords.left;
                        },
                        right: function () {
                            return originCoords.left + originCoords.width;
                        }
                    };

                    var shiftHeight = {
                        center: function () {
                            return originCoords.top + originCoords.height / 2 - popupHeight / 2;
                        },
                        top: function () {
                            return originCoords.top;
                        },
                        bottom: function () {
                            return originCoords.top + originCoords.height;
                        }
                    };

                    switch (pos0) {
                        case 'right':
                            placement = {
                                top: shiftHeight[pos1]() + (options.marginY || 0),
                                left: shiftWidth[pos0]() + (options.marginX || 0)
                            };
                            break;
                        case 'left':
                            placement = {
                                top: shiftHeight[pos1]() + (options.marginY || 0),
                                left: originCoords.left - popupWidth - (options.marginX || 0)
                            };
                            break;
                        case 'bottom':
                            placement = {
                                top: shiftHeight[pos0]() + (options.marginY || 0),
                                left: shiftWidth[pos1]() + (options.marginX || 0)
                            };
                            break;
                        default: // top
                            placement = {
                                top: originCoords.top - popupHeight - (options.marginY || 0),
                                left: shiftWidth[pos1]() + (options.marginX || 0)
                            };
                            break;
                    }

                    return placement;
                }

                function positionPopup(popupElement, elementOrCoords, options, scope) {

                    var deferred = $q.defer();

                    $timeout(function () {

                        if (!scope.$$phase) {
                            scope.$digest();
                        }

                        if (!popupElement) {
                            return;
                        }

                        // si son coords entonces asumo que son con respecto al Body
                        var elPosition = elementOrCoords;

                        if (elementOrCoords.length) {
                            elPosition = options.appendToBody ? $position.offset(elementOrCoords) : $position.position(elementOrCoords);
                        } else {
                            elPosition.width = elPosition.width || 0;
                            elPosition.height = elPosition.height || 0;
                        }

                        popupElement.css('right', '');

                        var position = getCoords(elPosition, popupElement, options);
                            
                        if (options.fillIfOutsideWindow
                            && (position.left < 0
                                || position.top < 0
                                || position.left + popupElement.width() > $(window).width()
                                || position.top + popupElement.height() > $(window).height())) {
                            popupElement.css({
                                right: 0,
                                left: 0,
                                top: 0,
                                position: 'absolute'
                            });
                        } else {

                            if (options.oppositeX) {
                                if (position.left < elPosition.left + elPosition.width / 2) {
                                    position.left += elPosition.width;
                                } else if (position.left > elPosition.left + elPosition.width / 2) {
                                    position.left -= elPosition.width;
                                }
                            }
                            
                            if (options.oppositeY) {
                                if (position.right < elPosition.top + elPosition.height / 2) {
                                    position.right += elPosition.height;
                                } else if (position.right > elPosition.top + elPosition.height / 2) {
                                    position.right -= elPosition.height;
                                }
                            }

                            if (popupElement.hasClass('popover')) {
                                popupElement.addClass(options.placement.split('-')[0]);
                            } else {
                                popupElement.children('.popover').addClass(options.placement.split('-')[0]);
                            }

                            position.position = 'absolute';
                            position.top += 'px';
                            position.left += 'px';
                            popupElement.css(position);

                            deferred.resolve();
                        }
                        
                    }, 100);

                    return deferred.promise;
                };

                var defaultOptions = {
                    appendToBody: true,
                    content: '',
                    contentUrl: null,
                    delay: 0,
                    html: false,
                    placement: 'top-center',
                    template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content popup-content"></div></div>',
                    title: '',
                    autohide: true, // si es true se interceptarán los eventos de click en otros elementos que no sean del popup y se ocultará el mismo.
                    autoremove: false, // si es true se interceptarán los eventos de click en otros elementos que no sean del popup y se removerá el mismo.
                    trigger: 'click',
                    triggerClose: null,
                    oppositeX: false, // si es true se colocará al resultado del lado opuesto del control en X.
                    focusObjectSelector: null
                }

                /*
                 * Crea un popup y retorna un objeto que permite mostrarlo, ocultarlo o removerlo.
                 */
                this.create = function create(elementOrCoords, options) {

                    var opt = angular.extend(defaultOptions, options);

                    var popupElement = $(opt.template);

                    popupElement.hide();
                    popupElement.css({ top: 0, left: 0, display: 'block' });

                    if (opt.appendToBody || !elementOrCoords.appendChild)
                        popupElement.appendTo('body');
                    else
                        popupElement.appendTo(elementOrCoords);

                    var destroying = false;

                    /*
                     * Obtengo el scope
                     */
                    var scope;

                    if (opt.scope) {
                        if (opt.scope.$watch) {
                            scope = opt.scope;
                        } else {
                            if ((scope = angular.element(elementOrCoords).scope()))
                                scope = angular.extend(scope.$new(), opt.scope);
                        }
                        if (!opt.dontDestroyScope)
                            popupElement.destroyScope = scope;
                    } else {
                        scope = angular.element(elementOrCoords).scope();
                    }

                    var popupCtrl,
                        contentPromise = null,
                        autoFn = null,
                        showCallbacks = [],
                        hideCallbacks = [],
                        removeCallbacks = [];

                    function hidePopup() {
                        popupElement.hide();
                        hideCallbacks.forEach(function (fn) {
                            fn.apply(popupCtrl);
                        });
                    };

                    /*
                     * Remueve el popup.
                     */
                    function removePopup() {
                        if (popupElement) {
                            if (popupElement.destroyScope && !destroying) {
                                destroying = true;
                                popupElement.destroyScope.$destroy();
                                popupElement.destroyScope = null;
                            }
                            if ($(popupElement).css('display') !== 'none') {
                                hideCallbacks.forEach(function (fn) {
                                    fn.apply(popupCtrl);
                                });
                                popupElement.hide();
                            }
                            popupElement.remove();
                        }

                        if (autoFn) {
                            $(document).off('click', autoFn);
                            $(window).off('resize', autoFn);
                        }

                        removeCallbacks.forEach(function (fn) {
                            fn.apply(popupCtrl);
                        });
                        hideCallbacks.length = 0;
                        removeCallbacks.length = 0;
                        showCallbacks.length = 0;
                    }
                    function focusWithoutScrolling(elem) {
                        var x = window.scrollX, y = window.scrollY;
                        elem.focus();
                        window.scrollTo(x, y);
                        return this; //chainability

                    };

                    function showPopup() {
                        positionPopup(popupElement, elementOrCoords, opt, scope)
                            .then(function () {
                                popupElement.show();
                                showCallbacks.forEach(function (fn) {
                                    fn.apply(popupCtrl);
                                });
                                if (opt.focusObjectSelector) {
                                    focusWithoutScrolling($(opt.focusObjectSelector));
                                }
                            });
                    };
                    
                    popupCtrl = {
                        remove: function() {
                            contentPromise.then(function() {
                                removePopup();
                            });
                        },
                        hide: function() {
                            contentPromise.then(function() {
                                hidePopup();
                            });
                        },
                        show: function() {
                            contentPromise.then(function() {
                                showPopup();
                            });
                        },
                        onShow: function (fn) {
                            showCallbacks.push(fn);
                        },
                        onHide: function (fn) {
                            hideCallbacks.push(fn);
                        },
                        onRemove: function (fn) {
                            removeCallbacks.push(fn);
                        }
                    };
                    
                    if (scope) {
                        scope.$on('$destroy', function () {
                            destroying = true;
                            removePopup();
                        });
                    }

                    if (opt.autohide || opt.autoremove) {

                        autoFn = function () {
                            // uso esto para evitar usar $apply.
                            $timeout((opt.autoremove) ? removePopup : hidePopup);
                        };

                        popupElement.on('click', function(evt) {
                            evt.stopImmediatePropagation();
                        });

                        if (options.triggerClose) {
                            element.on(options.triggerClose, autoFn);
                        }

                        $(document).on('click', autoFn);
                        $(window).on('resize', autoFn);
                    }

                    /*
                     * Seteo el contenido del popup.
                     */
                    var contentEl = popupElement.find('.popup-content');

                    if (contentEl.length === 0)
                        contentEl = popupElement;

                    if (opt.contentUrl) {
                        var content = null;
                        if ((content = $templateCache.get(opt.contentUrl))) {

                            if (typeof (content) === 'string')
                                contentEl.html(content);
                            else if (angular.isArray(content))  // es un request HTTP
                                contentEl.html(content[1]);

                            $compile(popupElement)(scope);

                            positionPopup(popupElement, elementOrCoords, opt, scope);

                            contentPromise = $q.when();

                        } else {

                            var deferred = $q.defer();

                            $http.get(options.contentUrl).
                                then(function(response) {

                                    $templateCache.put(options.contentUrl, response.data);

                                    contentEl.html(response.data);

                                    $compile(popupElement)(scope);

                                    positionPopup(popupElement, elementOrCoords, opt, scope);

                                    deferred.resolve();
                                }, function (result) {
                                    deferred.reject(result);
                                });

                            contentPromise = deferred.promise;
                        }
                    } else {

                        if (opt.html) {
                            contentEl.html(opt.content);
                            $compile(popupElement)(scope);
                        } else {
                            contentEl.text(opt.content);
                        }

                        positionPopup(popupElement, elementOrCoords, opt, scope);

                        contentPromise = $q.when();
                    }

                    // retorno un objeto que permite manipular el popup.
                    return popupCtrl;
                };
                
                /*
                 * Crea un popover para un elemento, que se abre o cierra segun el trigger especificado.
                 */
                this.popover = function (element, options) {
                    
                    var popup = this.create(element, options);
                    
                    function showPopup() {
                        popup.show();
                    };

                    if (options.trigger) {
                        element.on(options.trigger, showPopup);
                    }

                    return popup;
                }

            }
        ]);

})();